import type { TranslationMessages } from '../../types';

export const checklist: TranslationMessages = {
  title: 'Danh sách kiểm tra hàng ngày',
  subtitle:
    'Danh sách kiểm tra nhiệm vụ hàng ngày của bạn với tính năng theo dõi hoàn thành',
  loading: 'Đang tải danh sách kiểm tra...',
  today_tasks: 'Nhiệm vụ hôm nay',
  completed_tasks: 'Nhiệm vụ đã hoàn thành',
  pending_tasks: 'Nhiệm vụ đang chờ',
  task_completion: 'Hoàn thành nhiệm vụ',
  upload_evidence: 'Tải lên bằng chứng',
  add_notes: 'Thêm ghi chú',
  mark_complete: 'Đánh dấu hoàn thành',
  task_completed: 'Nhiệm vụ đã hoàn thành',
  completion_time: 'Thời gian hoàn thành',
  evidence_uploaded: 'Bằng chứng đã tải lên',
  manager_review: 'Quản lý xem xét',
  no_tasks: 'Không có nhiệm vụ nào được giao cho hôm nay',
  stats_completed: 'Đã hoàn thành',
  stats_progress: 'Tiến độ',
  stats_time_spent: 'Thời gian đã dành',
  stats_date: 'Ngày',
  add_custom_task: 'Thêm nhiệm vụ tùy chỉnh',
  add_item: 'Thêm mục',
  cancel: 'Hủy',
  task_title: 'Tiêu đề nhiệm vụ',
  task_title_placeholder: 'Nhập tiêu đề nhiệm vụ',
  description: 'Mô tả (Tùy chọn)',
  description_placeholder: 'Nhập mô tả nhiệm vụ',
  category: 'Danh mục',
  category_custom: 'Tùy chỉnh',
  category_opening: 'Mở cửa',
  category_closing: 'Đóng cửa',
  category_maintenance: 'Bảo trì',
  category_customer_service: 'Dịch vụ khách hàng',
  priority: 'Ưu tiên',
  priority_low: 'Thấp',
  priority_medium: 'Trung bình',
  priority_high: 'Cao',
  estimated_duration: 'Thời lượng ước tính (phút)',
  add_task_button: 'Thêm nhiệm vụ',
  tasks: 'Nhiệm vụ',
  category_opening_desc: 'Các nhiệm vụ cần hoàn thành khi mở cửa hàng',
  category_closing_desc: 'Các nhiệm vụ cần hoàn thành khi đóng cửa hàng',
  category_maintenance_desc: 'Các nhiệm vụ bảo trì và vệ sinh định kỳ',
  category_customer_service_desc:
    'Các nhiệm vụ dịch vụ khách hàng và tương tác',
  category_custom_desc: 'Các nhiệm vụ và ghi chú tùy chỉnh của bạn',
  completed_label: '✅ Đã hoàn thành',
  completed_at: 'vào lúc',
  failed_load: 'Không thể tải dữ liệu danh sách kiểm tra',
  add_title_required: 'Vui lòng nhập tiêu đề cho mục danh sách kiểm tra',
  item_added: 'Mục danh sách kiểm tra tùy chỉnh đã được thêm',
  item_updated: 'Mục danh sách kiểm tra đã được cập nhật thành công!',
  item_deleted: 'Mục danh sách kiểm tra đã được xóa thành công!',
  all_completed_title: '🎉 Tất cả nhiệm vụ đã hoàn thành!',
  all_completed_message:
    'Tuyệt vời! Bạn đã hoàn thành tất cả %{count} nhiệm vụ trong %{time} phút.',
  edit_title: 'Chỉnh sửa mục danh sách kiểm tra',
  edit_description:
    'Thực hiện thay đổi đối với mục danh sách kiểm tra bên dưới.',
  edit_duration_label: 'Thời lượng (phút)',
  save_changes: 'Lưu thay đổi',
  delete_title: 'Bạn có chắc chắn không?',
  delete_description:
    'Hành động này không thể hoàn tác. Điều này sẽ xóa vĩnh viễn mục danh sách kiểm tra.',
  delete_button: 'Xóa',
};
